import apiClient from './client';

export interface Model {
  id: string;
  name: string;
  description?: string;
  category?: {
    _id: string;
    name: string;
  } | null;
  brand?: {
    _id: string;
    name: string;
  } | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateModelRequest {
  name: string;
  description?: string;
  category: string;
  brand?: string;
}

export interface UpdateModelRequest {
  name?: string;
  description?: string;
  category?: string;
  brand?: string | null;
  isActive?: boolean;
}

export const modelsApi = {
  getAll: async (): Promise<Model[]> => {
    const response = await apiClient.get('/models');
    return response.data.map((model: any) => ({
      ...model,
      id: model._id,
    }));
  },

  getById: async (id: string): Promise<Model> => {
    const response = await apiClient.get(`/models/${id}`);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  getByCategory: async (categoryId: string): Promise<Model[]> => {
    const response = await apiClient.get(`/models/category/${categoryId}`);
    return response.data.map((model: any) => ({
      ...model,
      id: model._id,
    }));
  },

  create: async (data: CreateModelRequest): Promise<Model> => {
    const response = await apiClient.post('/models', data);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  update: async (id: string, data: UpdateModelRequest): Promise<Model> => {
    const response = await apiClient.put(`/models/${id}`, data);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/models/${id}`);
  },
};
